module.exports = __webpack_public_path__ + "static/media/drapeau.0782afa0.svg";